<div class="propriedade">
  <uib-tabset class="sidebar-historico" justified="true" active="propriedade.activeTab">
    <uib-tab index="0">
      <uib-tab-heading>
        <i class="fa fa-calendar"></i>
        Calendário
      </uib-tab-heading>
      <propriedade-calendar on-change="propriedade.onCalendarFiltersChange(data)"
                            disabled="propriedade.calendarDisabled"
                            filters="propriedade.filters"
                            shared-data="propriedade.sharedData"></propriedade-calendar>
      <propriedade-cards filters="propriedade.filters"
                         culturas-por-gleba="propriedade.culturasPorGleba"
                         ng-if="propriedade.ready"
                         class="calendar-tab"
                         ng-if="propriedade.activeTab === 0"></propriedade-cards>
    </uib-tab>
    <uib-tab index="1" select="propriedade.onShowHistoryTab()">
      <uib-tab-heading>
        <i class="fa fa-history"></i>
        Histórico
        <span ng-show="propriedade.historyNotificationCount" class="label label-danger">
          {{ propriedade.historyNotificationCount }}
        </span>
      </uib-tab-heading>
      <propriedade-historico culturas-por-gleba="propriedade.culturasPorGleba"
                             shared-data="propriedade.sharedData"
                             ng-if="propriedade.activeTab === 1"
                             has-unread-notifications="propriedade.historyNotificationCount > 0"></propriedade-historico>
    </uib-tab>
  </uib-tabset>
  <propriedade-map culturas-por-gleba="propriedade.cultivaresPorGleba || propriedade.culturasPorGleba"
                   custom-gleba-polygon-options="propriedade.customGlebaPolygonOptions"
                   legendas="propriedade.outrasLegendas || propriedade.legendas"
                   focused-gleba="propriedade.focusedGleba"
                   markers="propriedade.markers"
                   polylines="propriedade.polylines"
                   polygons="propriedade.polygons"
                   image-overlays="propriedade.imageOverlays"
                   active-heatmaps="propriedade.activeHeatmaps"
                   single-image-overlay="propriedade.singleImageOverlay"
                   default-polygons="propriedade.defaultPolygons"
                   head-map-type="propriedade.headMapType"
                   ></propriedade-map>
  <button type="button" class="btn btn-xs btn-toggle-historico" ng-click="propriedade.toggleHistorico()">
    <i class="fa" ng-class="propriedade.toggleHistoricoIconClass()"></i>
  </button>
  <div class="sidebar">
    <propriedade-buttons on-activate="propriedade.activateSidebar(name)"
                         active="propriedade.currentSidebar"
                         gleba="propriedade.focusedGleba"
                         weather-forecast="propriedade.weatherForecast"
                         show-weather-button="propriedade.weatherForecast !== 'error'"></propriedade-buttons>
    <propriedade-sidebar sidebar="propriedade.currentSidebar" data="propriedade.sidebarData" class="closed"
                         shared-data="propriedade.sharedData"></propriedade-sidebar>
  </div>
</div>
